// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"5e58a7ee","221":"b71efbb1","283":"2b07e6f5","398":"2ef14317","511":"a1bb758b","548":"654a0433","592":"594cf195","620":"171f901a","934":"ce9d2b8d","953":"a59525e8"}[chunkId] + ".chunk.js";
};